import React from "react";
import { Link } from "react-router-dom";
import {
  FaLinkedinIn,
  FaInstagram,
  FaFacebookF,
  FaXTwitter,
  FaYoutube,
} from "react-icons/fa6";
import langData from "../locales/langData.json";
import footerLogo from "../assets/images/footer-logo.svg";
import footerLogowhite from "../assets/images/arabhi-logo-white.webp";


const Footer = ({ language }) => {
  const footer = langData[language].home.footer;

  // Example: define actual social links
  const socialLinks = {
    linkedin: "https://www.linkedin.com/company/captainx",
    instagram: "https://www.instagram.com/captainx.ai",
    facebook: "https://www.facebook.com/CaptainXAI",
    twitter: "https://x.com/captainx_ai",
    youtube: "https://youtube.com/@captainx_ai",
  };

  return (
    <div className="footer">
      <div className="footer-bg"></div>
      <div className="container">
        <div className="row pt-5">
          {/* Left Column */}
          <div className="col-md-6 col-lg-5">
            <img
              src={language === "ar" ? footerLogowhite : footerLogo}
              alt="logo"
              className="img-fluid"
            />

            <p className="footer-desc py-3">{footer.desc}</p>

 <div className="footer-head mb-2">
              <h5>{footer.followTitle}</h5>
              <div className="social-icons">

                <div className="ico">
                  <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer">
                    <FaLinkedinIn />
                  </a>
                </div>

                <div className="ico">
                  <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer">
                    <FaInstagram />
                  </a>
                </div>

                <div className="ico">
                  <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer">
                    <FaFacebookF />
                  </a>
                </div>

                <div className="ico">
                  <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer">
                    <FaXTwitter />
                  </a>
                </div>

                <div className="ico">
                  <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer">
                    <FaYoutube />
                  </a>
                </div>

              </div>

            </div>
           

          </div>
{/* ✅ Social Icons */}
          <div className="col-md-4 col-lg-3">
            {/* ✅ Quick Links */}
            <div className="footer-head ">
              <h5>{footer.quickLinksTitle}</h5>
              <ul className="footer-links z-5">
                {footer.quickLinks?.map((link, index) => {
                  const slug = link.key === "home" ? "/" : `/${link.key}`;
                  return (
                    <li key={index}>
                      <Link to={slug}>{link.label}</Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
          {/* ✅ Contact */}
          <div className="col-md-3 col-lg-2">
            <div className="footer-head">
              <h5>{footer.contactTitle}</h5>
              <p>
                <a href={`tel:${footer.phonelink}`} className="footer-contact-link">
                  {footer.phone}
                </a>
              </p>
              <p>
                <a
                  href={`mailto:${footer.email}`}
                  className="footer-contact-link"
                >
                  {footer.email}
                </a>
              </p>
            </div>
          </div>

          {/* ✅ Location */}
          <div className="col-md-3 col-lg-2">
            <div className="footer-head">
              <h5>{footer.locationTitle}</h5>
              <p>{footer.address}</p>
            </div>
          </div>

          
        </div>
      </div>
    </div>
  );
};

export default Footer;
